import React from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import ReceiptItem from 'components/common/receipt/receipt_item';
import { ADJUSTMENT_TYPE_MAPPINGS } from 'constants/mappings';

const DiscountReceiptItems = (props) => {
  const { t } = useTranslation();

  const { orderData, discountType } = props;

  const adjustmentItems = orderData.discounts.map((d) =>
    d.adjustments
      .filter(
        (adj) => !discountType || (discountType && adj.type === discountType),
      )
      .flatMap((adj, index) => (
        <ReceiptItem
          key={`${d.code}-${index}`}
          label={ADJUSTMENT_TYPE_MAPPINGS[adj.type]}
          cost={adj.amount}
          currency={d.currency}
          negativeZero={true}
          leftOffset={3}
        />
      )),
  );

  const discounts = adjustmentItems.flatMap((adjustments, index) =>
    adjustments.length > 0 ? (
      <div key={index}>
        <p className="paragraph-20">
          {t('checkout.receipt.label.promotion', {
            code: orderData.discounts[index].name,
          })}
        </p>
        {adjustments}
      </div>
    ) : (
      []
    ),
  );

  return (
    discounts.length > 0 && (
      <>
        <Divider sx={{ my: 2 }} />
        {discounts}
      </>
    )
  );
};

export default DiscountReceiptItems;
